export default "__VITE_PUBLIC_ASSET__ca501740__"